export const themes = {
  default: {
    thItem: 'relative py-10',
    thContent: 'flex',
    thContentNoDetails: '',
    thContentOpen: 'font-bold',
    thIconContainer: 'ms-10 cursor-pointer self-center',
    thIconSize: '1rem',
    thIcon: 'text-black align-top',
    thSubContent: 'pe-30',
    thDetails: 'pt-10',
    thDetailsItem: 'm-0 px-15',
  },
  legacy: {
    thItem: 'relative p-20',
    thIndicator:
      'absolute start-0 bg-black w-0 p-1 transition-transform duration-250 ease-in scale-0',
    thIndicatorOpen: 'transform scale-1',
    thContent: 'flex text-16',
    thContentNoDetails: 'me-30',
    thContentOpen: 'font-bold',
    thIconContainer: 'ms-10 cursor-pointer',
    thIconSize: '1.25rem',
    thIcon: 'text-black align-top',
    thSubContent: 'pe-30',
    thDetails: 'pt-10',
    thDetailsItem: 'm-0 px-15',
  },
};
